import { useQuery } from '@tanstack/react-query';

import { getAccountKycAml } from '@arrived/api_v2';
import { AccountKycAml } from '@arrived/models';

import { UseQueryOptions, UseQueryResult } from '../../queries.utils';
import { useGetPrimaryAccountQuery } from '../../users';
import { accountKycAmlKeyFn } from './accountKycAml.keys';

export function useGetPrimaryAccountKycAmlQuery(
  options?: UseQueryOptions<AccountKycAml>
): UseQueryResult<AccountKycAml> {
  const accountState = useGetPrimaryAccountQuery();
  const { id: accountId } = accountState.data || {};

  return useQuery(accountKycAmlKeyFn(accountId!), () => getAccountKycAml(accountId!), {
    ...options,
    enabled: (options?.enabled ?? true) && accountId != null,
  });
}
